import { LINK_TITLE } from '../elements/link'

export const HERO_WITH_IMAGE_AND_TEXT_CAROUSEL = `
...on heroWithImageAndTextCarousel_Entry {
  id
  typeHandle
  
  headingAdvanced { html }
  description
  ${ LINK_TITLE }
  images {
    url
    title
    height
    width
  }
  headingTable {
    id
    heading
  }
}
`